import FullSite from "./full-site";
import { CashoutTemplate } from "../../jamibet/desktop-pages/cashout";

export default function Cashout() {
	return <FullSite><CashoutTemplate /></FullSite>;
}
